export default "__VITE_ASSET__DBsdHHgC__"